import React, { useEffect, useState } from 'react';
import { getLearners } from '../../services/learnerService';
import { debounce } from '../Common/Debounce';
import { Form, Modal, Select, Spin, Button, Typography } from 'antd';
import '../Common/Form.css';

const { Text } = Typography;

const CourseEnrolmentModal = (props) => {
  const isVisible = props.isVisible;
  const setIsVisible = props.setIsVisible;
  const handleOk = props.handleOk;
  const title = props.title;
  const formData = props.formData;
  const updateFormData = props.updateFormData;
  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(false);
  const [fetchedLearners, setFetchedLearners] = useState([]);
  const [status, setStatus] = useState({
    error: false,
    message: ''
  });

  const formItemLayout = {
    labelCol: { span: 7 },
    wrapperCol: { span: 21 }
  };

  const handleFormChange = (e) => {
    console.log('Event', e);

    updateFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const fetchLearnersHandler = debounce((value) => {
    setFetching(true);
    console.log(value);
    getLearners(0, 0, {
      name: value,
      sortBy: 'firstName',
      sortOrder: 'asc'
    })
      .then((response) => {
        const data = response.data.paginatedList.map((learner) => ({
          label: `${learner.firstName} ${learner.lastName} (${learner.email})`,
          value: learner.learnerId
        }));
        setFetchedLearners(data);
        setFetching(false);
      })
      .catch((err) => {
        setStatus({
          error: true,
          message: `${err}`
        });
      });
  }, 250);

  return (
    <Modal
      visible={isVisible}
      title={title}
      onOk={handleOk}
      onCancel={() => setIsVisible(false)}
      footer={[
        <Button
          key="submit"
          type="primary"
          loading={loading}
          onClick={handleOk}>
          Submit
        </Button>
      ]}>
      <Form {...formItemLayout}>
        <section>
          <Form.Item label="Course Offer Id*">
            <Text>{formData.courseOfferId}</Text>
          </Form.Item>
          <Form.Item label="Course Offer Code*">
            <Text>{formData.courseOfferCode}</Text>
          </Form.Item>
          <Form.Item label="Learner*">
            {title.toLowerCase().includes('add') ? (
              <Select
                mode={''}
                placeholder="Search learners"
                options={fetchedLearners}
                notFoundContent={fetching ? <Spin size="small" /> : null}
                filterOption={false}
                showSearch={true}
                onSearch={fetchLearnersHandler}
                onChange={(value) => {
                  const e = {
                    target: { name: 'learnerId', value: value }
                  };
                  handleFormChange(e);
                }}
                style={{ width: '100%' }}></Select>
            ) : (
              <Text>{formData.firstName + ' ' + formData.lastName}</Text>
            )}
          </Form.Item>

          {status.error ? (
            <div style={{ margin: '10px', textAlign: 'center' }}>
              <Text type="danger">{status.message}</Text>
            </div>
          ) : (
            <></>
          )}

          <Form.Item label="Status">
            <Select
              defaultValue={formData.courseEnrolmentStatus}
              onSelect={(value) => {
                const e = {
                  target: { name: 'courseEnrolmentStatus', value: value }
                };
                handleFormChange(e);
              }}>
              <Select.Option value="Pending">
                Pending - Paid Deposit Only
              </Select.Option>
              <Select.Option value="Current">
                Current - Fully Paid
              </Select.Option>
              <Select.Option value="Inactive">
                Inactive - ...
              </Select.Option>
              <Select.Option value="Completed">
                Completed - Completed course offer
              </Select.Option>
              <Select.Option value="Transferred">
                Transferred - Transferred to another course offer
              </Select.Option>
              <Select.Option value="Withdrawn">
                Withdrawn - Withdrawn
              </Select.Option>
              <Select.Option value="Cancelled">
                Cancelled - Enrolment cancelled
              </Select.Option>
              <Select.Option value="Withhold">
                Withhold - Enrolment withhold
              </Select.Option>
            </Select>
          </Form.Item>
        </section>
      </Form>
    </Modal>
  );
};

export default CourseEnrolmentModal;
